import { LABELS } from "~/resources/Labels";
import {FormCloudEnvironmentResponse} from "~/models/Commons ";
import { SIMPLDialog } from "../.././components/commons/dialog/SimplDialog";
import { getCloudProviderName } from "~/Utils/Utils";

interface DetailProps {
  item: FormCloudEnvironmentResponse;
  onClose: () => void;
}

const valueClass =
  "py-3 px-2 bg-[#efefef] rounded-md break-words max-w-[600px]";
const labelClass = "font-semibold max-w-[300px]";
export const DetailViewCloudEnvironment = ({ item, onClose }: DetailProps) => {
  return (
    <SIMPLDialog onCloseModal={onClose} title={LABELS.DetailView}>
      <div className="w-auto pb-5 flex flex-col">
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{"Name"}</div>
            <div className={valueClass}>{item.environmentName}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{"Description"}</div>
            <div className={valueClass}>{item?.environmentDescription}</div>
          </div>
        </div>
        <div className="flex-1">
          <div className={labelClass}>{"DataCenter Name"}</div>
          <div className={valueClass}>{item.datacenterName}</div>
        </div>
        <div className="flex-1">
          <div className={labelClass}>{"DataCenter Description"}</div>
          <div className={valueClass}>{item?.datacenterDescription}</div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.Provider}</div>
            <div className={valueClass}>
              {getCloudProviderName(item.cloudProvider)}
            </div>
          </div>
        </div>

        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.Location}</div>
            <div className={valueClass}>{item.location}</div>
          </div>
        </div>

        <div className="flex flex-row mt-3">
          <div className="flex-1 truncate">
            <div className={labelClass}>{"Iac"}</div>
            <div className={valueClass}>{item.iac}</div>
          </div>
        </div>
      </div>
    </SIMPLDialog>
  );
};
